import React, { PropTypes, PureComponent } from 'react';

import LegendItemColor from './LegendItemColor';

class LegendItem extends PureComponent {
  render() {
    const legendItemColors = this.props.ranges.map((item, index) =>
      <LegendItemColor
        key={`legend_item_color_${index}`}
        scale_icon={item.scale_icon}
        color={item.color}
        rangesCount={this.props.ranges.length}
      />
    );

    return (<div className="mt-legend-item">
      {legendItemColors}
      <span className="mt-legend-item-text" dangerouslySetInnerHTML={{ __html: this.props.text }}></span>
    </div>);
  }
}

LegendItem.defaultProps = {
  ranges: [],
  text: '',
};

LegendItem.propTypes = {
  ranges: PropTypes.array,
  text: PropTypes.string,
};

export default LegendItem;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/Legend/LegendItem.js
 **/